import SendingRateToken from '@apps/maha/admin/tokens/sending_rate_token'
import Panel from '@admin/components/panel'

const mapPropsToPanel = (props, context) => ({
  title: 't(Subdomains)',
  collection: {
    endpoint: `/api/admin/truevail/admin/deliverability/domain_segments/${props.domain_segment.id}/subdomains`,
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Name)', key: 'domain.name', primary: true },
      { label: 't(Queued)', key: 'queued_count', collapsing: true, align: 'right' },
      { label: 't(Rate)', key: 'sending_rate', collapsing: true, align: 'right', format: SendingRateToken }
    ],
    defaultSort: { key: 'name', order: 'asc' },
    empty: {
      svg: 'globe',
      title: 't(No Subdomains)',
      text: 't(There are no subdomains)'
    },
    entity: 'subdomain',
    onClick: (record) => context.router.push(`/admin/truevail/admin/domain_segments/${record.id}`)
  }
})

export default Panel(null, mapPropsToPanel)